(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["af-pack-picker"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = (scope = document) => {
      scope.querySelectorAll('[data-avistouch-packs]').forEach(picker => {
        if (picker.dataset.initialized) return;
        picker.dataset.initialized = 'true';
        const update = () => {
          const selected = picker.querySelector('[data-pack-choice]:checked');
          if (!selected) return;
          picker.querySelectorAll('[data-pack-output]').forEach(output => {
            output.textContent = selected.dataset[output.dataset.packOutput] || '';
          });
          const button = picker.querySelector('[data-pack-add]');
          button.textContent = selected.dataset.action;
          button.disabled = selected.dataset.available !== 'true';
        };
        picker.addEventListener('change', event => {
          if (event.target.matches('[data-pack-choice]')) update();
        });
        update();
      });
    };
    initialize();
    document.addEventListener('shopify:section:load', event => initialize(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
